import type React from 'react';
import { useEffect } from 'react';
import { ConfigProvider } from 'antd';

import CustomLoader from 'components/common/CustomLoader';
import { useLoadCss } from 'hooks/useLoadCss';
import RouteCenter from 'routes';
import { useAppDispatch, useAppSelector } from 'store/customHooks';
import { handleHeaderLogo } from 'store/header/headerSlice';

import 'App.css';
import 'styles/index.scss';

const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const globalLoader = useAppSelector((state) => state.auth.globalLoader);
  const tenant = JSON.parse(sessionStorage.getItem('CustomerApp-Tenant') || '{}');

  const tenantStyles = JSON.parse(sessionStorage.getItem('CustomerApp-Styles') || '{}');

  useLoadCss();

  useEffect(() => {
    dispatch(
      handleHeaderLogo({
        defaultHeaderLogo: tenantStyles.defaultHeaderLogo,
        headerLogo: tenantStyles.headerLogo,
        altName: tenant?.tenantName || 'default',
      }),
    );
  }, [tenantStyles, tenant]);

  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: tenantStyles.fontFamily || 'Roboto Condensed, sans-serif',
        },
      }}
    >
      {globalLoader && <CustomLoader isLoading={globalLoader} />}
      <div className='typography'>
        <RouteCenter />
      </div>
    </ConfigProvider>
  );
};

export default App;
